import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const valeurs = [
  { titleKey: 'valeur_1_title', descKey: 'valeur_1_desc', icon: 'ri-eye-line' },
  { titleKey: 'valeur_2_title', descKey: 'valeur_2_desc', icon: 'ri-shield-star-line' },
  { titleKey: 'valeur_3_title', descKey: 'valeur_3_desc', icon: 'ri-map-pin-2-line' },
  { titleKey: 'valeur_4_title', descKey: 'valeur_4_desc', icon: 'ri-user-follow-line' },
];

export default function NosValeurs() {
  const { t } = useTranslation('apropos');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="valeurs" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('valeurs_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {valeurs.map((v, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl p-6 md:p-8 text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-copper/10 mx-auto mb-5">
                <i className={`${v.icon} text-copper text-2xl`} />
              </div>
              <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base tracking-wide mb-3">
                {t(v.titleKey)}
              </h3>
              <p className="text-slate-primary/50 text-sm leading-relaxed">{t(v.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}